export default {
    SET_FILTER_TECHNOLOGY (state, filters) {
      state.filters.technologyFilter = filters
    },
    SET_FILTER_STARTUPPHASE (state, filters) {
      state.filters.startupPhaseFilter = filters
    },
    SET_FILTER_UNIVERSITY (state, filters) {
      state.filters.universityFilter = filters
    },
    SET_FILTER_COUNTRY_B_P (state, filters) {
      state.filters.countryBPFilter = filters
    },
    SET_FILTER_CANTON (state, filters) {
      state.filters.cantonFilter = filters
    },
    SET_FILTER_LEGALFORM (state, filters) {
      state.filters.legalformFilter = filters
    },
    SET_FILTER_CASESTATUS (state, filters) {
      state.filters.caseStatusFilter = filters
    },
    SET_FILTER_ROLES (state, filters) {
      state.filters.roles = filters
    },
    SET_FILTER_VEKMIS_TECHNOLOGY (state, filters) {
      state.filters.vekmisTechnology = filters
    },
    SET_FILTER_PRIO_VLAB_TYPE (state, filters) {
      state.filters.prioVlabType = filters
    },
    SET_FILTER_PRIO_XMAS_TYPE (state, filters) {
      state.filters.prioXmasType = filters
    },
    SET_FILTER_ADDRESS_INTERESTS (state, filters) {
      state.filters.addressInterests = filters
    },
    SET_EVENT_TITLES (state, eventTitles) {
      state.eventTitles = eventTitles
    },
    SET_FILTER_EVENT_TITLES (state, filters) {
      state.filters.eventTitles = filters
    },
    SET_EVENTPOOL_THEMES (state, eventPoolThemes) {
      state.eventPoolThemes = eventPoolThemes
    },
    SET_FILTER_EVENTPOOL_THEMES (state, filters) {
      state.filters.eventPoolThemes = filters
    },
    SET_FILTER_CITY_B_P (state, filters) {
      state.filters.cityBP = filters
    },
    SET_FILTER_ZIP_B_P (state, filters) {
      state.filters.zipBP = filters
    },
    SET_FILTER_SALUTATION (state, filters) {
      state.filters.salutation = filters
    },
    SET_FILTER_UNI_SPIN_OFF (state, filters) {
      state.filters.unispinoff = filters
    },
    SET_FILTER_AWARDS (state, filters) {
      state.filters.awards = filters
    },
    SET_FILTER_SECTORS (state, filters) {
      state.filters.sectors = filters
    },
    SET_FILTER_INCORPORATION_DATE (state, filters) {
      state.filters.incorporationDate = filters
    },
    SET_FILTER_TOTAL_FUNDING (state, filters) {
      state.filters.totalFunding = filters
    },
    SET_FILTER_REPORTING_GROUPS (state, filters) {
      state.filters.reportingGroups = filters
    },
    SET_FILTER_EVENT_SORTDATE (state, filters) {
      state.filters.eventSortDate = filters
    },
    SET_INTERESTS_STATUS (state, interestsStatus) {
      state.interestsStatus = interestsStatus
    },
    SET_FILTER_INTERESTS_BY_STATUS (state, filters) {
      state.filters.interestsByStatus = filters
    },
    SET_FILTER_AFFIRMATION (state, filters) {
      state.filters.affirmation = filters
    },
    SET_FILTER_COMBINED_EVENT_AFFIRMATION (state, filters) {
      state.filters.combinedEventTitleAffirmation = filters
    },
    SET_FILTER_COMBINED_THEME_AFFIRMATION (state, filters) {
      state.filters.combinedThemeAffirmation = filters
    }
  }
